export default __webpack_public_path__ + "3e9c66e2a2bd93d2ff32080c01afcb71.png";